import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports-monitor',
  templateUrl: './reports-monitor.component.html',
  styleUrls: ['./reports-monitor.component.less']
})
export class ReportsMonitorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/stats/reports-monitor/reports-monitor.component.ts